module.exports = "https://static.wmbcdn.com/uniweb/images/83dde99d02c132e3502e1fd7219d2e80.svg";